module.exports = __webpack_public_path__ + "static/img/4.65af6026.png";